import { CuestionarioRespuestaDto } from "./cuestionario-respuesta-dto";

export class EvaluacionDto {
    docente: number;
    evaludaor: string;
    periodo: number;
    observacion: string;
    cuestionario: number;
    tipoEvaluador: number;
    curso: number;
    lstCuestionarioRespuestaDto: CuestionarioRespuestaDto[];
}
